import { Container } from 'pixi.js';
import { ease } from 'pixi-ease';
class PlayerGraphics extends Container {
  public fadeIn(duration: number) {
    ease.add(this, { alpha: 1 }, { duration });
  }

  public fadeOut(duration: number, stopPoint: number) {
    ease.add(this, { alpha: stopPoint }, { duration });
  }
}

export default PlayerGraphics;
